import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGasPump, FaCogs, FaShip, FaGlobeAmericas, FaSearchPlus } from 'react-icons/fa';

const CaracasHero = () => {
    const navigate = useNavigate();
    const [isShaking, setIsShaking] = useState(false);

    // Ajustamos la ruta según tu estructura de carpetas actual
    const BUCKET_URL = "/Caracas_Hero/";

    const handleClick = () => {
        setIsShaking(true);
        setTimeout(() => {
            setIsShaking(false);
            navigate('/vehiculo/frontlander-2025-ccs');
        }, 500);
    };

    const customAnimations = `
        @keyframes shake {
            0% { transform: translate(1px, 1px) rotate(0deg); }
            10% { transform: translate(-1px, -2px) rotate(-1deg); }
            30% { transform: translate(3px, 2px) rotate(0deg); }
            50% { transform: translate(-1px, 2px) rotate(-1deg); }
            70% { transform: translate(3px, 1px) rotate(-1deg); }
            100% { transform: translate(1px, -2px) rotate(-1deg); }
        }
        @keyframes glowing-button {
            0% { box-shadow: 0 0 5px #dc3545; }
            50% { box-shadow: 0 0 25px #ff4d5e; }
            100% { box-shadow: 0 0 5px #dc3545; }
        }
    `;

    return (
        <div style={{ 
            fontFamily: "'Inter', sans-serif", 
            maxWidth: '1200px', 
            margin: '40px auto', 
            padding: '0 15px', 
            textAlign: 'center',
            overflowX: 'hidden' 
        }}>
            <style>{customAnimations}</style>

            {/* 🏷️ Título Responsivo */}
            <div style={{ marginBottom: '40px' }}>
                <span style={{ color: '#dc3545', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.9em' }}>
                    Vimcarbroker Venezuela
                </span>
                <h2 style={{ 
                    fontSize: 'clamp(2em, 8vw, 3.5em)', 
                    fontWeight: '900', 
                    margin: '10px 0', 
                    lineHeight: '1.1', 
                    color: '#111827' 
                }}>
                    Toyota Frontlander 2025 <br/>
                    <span style={{ color: '#dc3545' }}>Ya Disponible en Caracas</span>
                </h2>
                <p style={{ fontSize: 'clamp(1em, 3vw, 1.2em)', color: '#4b5563', maxWidth: '700px', margin: '0 auto', lineHeight: '1.5' }}>
                    0 KM, lista para entrega inmediata. <br/>
                    Importamos el auto de tus sueños desde <strong>USA y China</strong>.
                </p>
            </div>

            {/* 💳 Tarjeta Principal */}
            <div 
                style={{
                    background: 'linear-gradient(165deg, #0f172a 0%, #000000 100%)',
                    borderRadius: '30px',
                    padding: '60px 20px 40px 20px',
                    position: 'relative',
                    border: '1px solid #1e293b',
                    boxShadow: '0 30px 60px -12px rgba(0, 0, 0, 0.5)',
                    animation: isShaking ? 'shake 0.5s' : 'none',
                }}
            >
                {/* 💰 Precio Adaptable */}
                <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '50%',
                    transform: 'translateX(50%)',
                    background: '#dc3545',
                    color: 'white',
                    padding: '12px 25px',
                    borderRadius: '15px',
                    fontSize: 'clamp(1.5em, 5vw, 2em)',
                    fontWeight: '900',
                    boxShadow: '0 10px 20px rgba(220, 53, 69, 0.3)',
                    whiteSpace: 'nowrap',
                    zIndex: 2
                }}>
                    $46,000
                </div>

                {/* 🚗 Galería Responsiva */}
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'row', 
                    flexWrap: 'wrap', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    gap: '20px', 
                    marginBottom: '40px',
                    marginTop: '20px'
                }}>
                    <img 
                        src={`${BUCKET_URL}Frontlander_Hero1.png`} 
                        alt="Front" 
                        style={{ width: '100%', maxWidth: '400px', height: 'auto', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.8))' }} 
                    />
                    <img 
                        src={`${BUCKET_URL}Frontlander_Hero2.png`} 
                        alt="Side" 
                        style={{ width: '100%', maxWidth: '400px', height: 'auto', filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.8))' }} 
                    />
                </div>

                {/* 🛠️ Grid de Especificaciones */}
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', 
                    gap: '20px', 
                    color: 'white', 
                    borderTop: '1px solid #1e293b', 
                    paddingTop: '30px' 
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <FaCogs style={{ fontSize: '28px', color: '#dc3545', marginBottom: '8px' }} />
                        <p style={{ fontWeight: 'bold', margin: '0', fontSize: '0.8em', letterSpacing: '1px' }}>MOTOR</p>
                        <p style={{ fontSize: '0.8em', color: '#9ca3af' }}>2.0L Dynamic Force</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <FaGasPump style={{ fontSize: '28px', color: '#dc3545', marginBottom: '8px' }} />
                        <p style={{ fontWeight: 'bold', margin: '0', fontSize: '0.8em', letterSpacing: '1px' }}>ESTADO</p>
                        <p style={{ fontSize: '0.8em', color: '#9ca3af' }}>Unidad 0 KM</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <FaShip style={{ fontSize: '28px', color: '#dc3545', marginBottom: '8px' }} />
                        <p style={{ fontWeight: 'bold', margin: '0', fontSize: '0.8em', letterSpacing: '1px' }}>LOGÍSTICA</p>
                        <p style={{ fontSize: '0.8em', color: '#9ca3af' }}>Entrega Garantizada</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <FaGlobeAmericas style={{ fontSize: '28px', color: '#dc3545', marginBottom: '8px' }} />
                        <p style={{ fontWeight: 'bold', margin: '0', fontSize: '0.8em', letterSpacing: '1px' }}>GLOBAL</p>
                        <p style={{ fontSize: '0.8em', color: '#9ca3af' }}>USA / Asia / Europa</p>
                    </div>
                </div>

                {/* 🟢 Botón Full Responsivo */}
                <button 
                    onClick={handleClick}
                    style={{
                        marginTop: '40px',
                        padding: '18px 30px',
                        background: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50px',
                        fontSize: 'clamp(0.9em, 4vw, 1.1em)',
                        fontWeight: '900',
                        cursor: 'pointer',
                        width: '100%',
                        maxWidth: '450px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px',
                        transition: 'all 0.3s ease',
                        textTransform: 'uppercase'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.animation = 'glowing-button 1.5s infinite'}
                    onMouseLeave={(e) => e.currentTarget.style.animation = 'none'}
                >
                    <FaSearchPlus /> VER ESPECIFICACIONES
                </button>
            </div>
            
            {/* Pie de página pequeño */}
            <div style={{ marginTop: '30px', background: '#f3f4f6', padding: '15px', borderRadius: '15px' }}>
                <p style={{ color: '#1f2937', fontSize: '0.9em', margin: 0 }}>
                    🚀 <strong>Importación Directa:</strong> Traemos cualquier vehículo a Venezuela.
                </p>
            </div>
        </div>
    );
};

export default CaracasHero;